"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageList = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Launch_1 = __importDefault(require("@mui/icons-material/Launch"));
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const Message_1 = __importDefault(require("./Message"));
const services_1 = require("../../../common/services");
const ActivityListItem_1 = require("../Other/ActivityListItem");
const CardSkeleton_1 = require("../Skeletons/CardSkeleton");
const MessageListWrapper = styled_components_1.default.div `
  flex-grow: 1;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .messages-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .message-group {
      border-left: 5px solid #f5f5f5;
      border-radius: 5px;

      margin-bottom: 20px;
      padding-left: 10px;

      .group-header {
        letter-spacing: 2px;
        font-weight: bold;
        margin-bottom: 6px;
      }
    }
  }

  hr {
    margin: 20px 0;
  }
`;
const MainNotificationContainer = styled_components_1.default.div `
  display: flex;
  gap: 10px;
  position: relative;
  padding: 10px;
  margin-bottom: 16px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  @media (min-width: 1000px) {
    margin-top: 38px;
  }

  svg {
    position: absolute;
    right: 5px;
    bottom: 5px;
    cursor: pointer;
  }
`;
const MainNotificationImg = styled_components_1.default.div `
  display: flex;
  height: 120px;
  width: 120px;

  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }

  .image-placeholder {
    height: 120px;
    width: 120px;
    background: linear-gradient(
      12deg,
      ${props => props.theme.palette.mainAppColor.dark} 5%,
      ${props => props.theme.palette.mainAppColor.light} 25%,
      ${props => props.theme.palette.mainAppColor.main} 100%
    );
    border-radius: 10px;

    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }

  img {
    border-radius: 10px;
  }
`;
const MainNotificationBody = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 3px 0px;
  overflow: hidden;

  .notification-status {
    color: rgba(0, 0, 0, 0.6);
  }

  .main-notification-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const MainNotificationTimeAndDate = styled_components_1.default.div `
  min-height: 30px;
  display: flex;
  background-color: #f7f7f7;
  border-radius: 5px;
  flex-shrink: 0;

  p {
    color: rgba(0, 0, 0, 0.6);
    border-radius: 2px;

    &.add-padding {
      padding: 5px;
    }
  }
`;
const NotificationAvailability = styled_components_1.default.div `
  min-height: 24px;
  display: flex;
  align-items: flex-end;

  .booking-status {
    margin-right: 6px;
  }
`;
const PlaceAndDate = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  @media (max-width: 420px) {
    flex-wrap: wrap;
  }
`;
const PlaceName = styled_components_1.default.div `
  padding: 5px 0;
  margin-right: 5px;
  display: flex;
  color: #807e7e;
  svg {
    position: relative;
    right: 0;
    bottom: 0;
    font-size: 0.8rem;
    top: 4px;
  }
  p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const SelectNotificationMsg = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  .notifications-icon {
    font-size: 75px;
    padding: 15px;
    border-radius: 50%;
    background-color: #e1e6e8;
    margin-bottom: 25px;
    overflow: visible;
  }
`;
const MessageList = ({ selectedNotification, messages, directoryData, offers, currentLocale, userData, history, }) => {
    var _a, _b;
    const messageType = (_a = selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.reference) === null || _a === void 0 ? void 0 : _a.type;
    const messageSection = selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.reference.section;
    // if activity fetch it's details
    const [activity, setActivity] = (0, react_1.useState)(null);
    const [folder, setFolder] = (0, react_1.useState)(null);
    const [fetchingActivity, setFetchingActivity] = (0, react_1.useState)(false);
    const content = selectedNotification && {
        contentId: (_b = selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.reference) === null || _b === void 0 ? void 0 : _b.id,
    };
    (0, react_1.useEffect)(() => {
        // don't fetch if selecting message for the same activity
        if (messageType === 'folder') {
            services_1.apiService
                .getFolderInfo(currentLocale, userData.token, `${content.contentId}`)
                .then((folderData) => {
                setFolder(folderData.folder);
            })
                .catch((error) => {
                console.error('Error fetching folder info:', error);
            });
            return;
        }
        if (activity && `${activity.id}` === content.contentId) {
            return;
        }
        if (messageType === 'activity') {
            setFetchingActivity(true);
            services_1.apiService.getActivity(currentLocale, userData.token, `${content.contentId}`).then(detailData => {
                setFetchingActivity(false);
                setActivity(detailData);
            });
        }
        else {
            setActivity(null);
        }
    }, [messages]);
    // if directory or offer search inside the already fetched collections
    let offerOrDirectory = null;
    if (messageType !== 'activity') {
        const flattenedDirectoriesOrOffers = messageSection === 'directory' ? helpers_1.Helpers.flattenCollection(directoryData) : helpers_1.Helpers.flattenCollection(offers);
        const foundOfferOrDirectory = messages.length !== 0 &&
            (flattenedDirectoriesOrOffers === null || flattenedDirectoriesOrOffers === void 0 ? void 0 : flattenedDirectoriesOrOffers.find((offerOrDirectoryInterated) => { var _a, _b; return `${(_a = offerOrDirectoryInterated[messageType]) === null || _a === void 0 ? void 0 : _a.contentId}` === ((_b = selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.reference) === null || _b === void 0 ? void 0 : _b.id); }));
        offerOrDirectory = foundOfferOrDirectory && foundOfferOrDirectory[messageType];
    }
    const messagesGroupedByDay = messages.length ? groupMessagesPerDay(messages, currentLocale) : [];
    const activityTime = messageType === 'activity' &&
        activity &&
        !helpers_1.Helpers.isEmptyObject(activity) &&
        getActivityTime(activity, currentLocale);
    const activityDate = messageType === 'activity' &&
        activity &&
        !helpers_1.Helpers.isEmptyObject(activity) &&
        getActivityDate(activity.start, currentLocale);
    const dateTimeClassName = activityTime || activityDate ? 'add-padding' : '';
    function handleNotificationClick(selectedNotification, content, offerOrDirectory) {
        if (!selectedNotification || !selectedNotification.reference) {
            console.warn('No valid notification selected:', selectedNotification);
            return;
        }
        const { type, section, externalUrl, id } = selectedNotification.reference;
        if (section === 'bookings') {
            helpers_1.Helpers.openModal(modalEnums_1.default.BOOKING_DETAILS, {
                booking: { code: id },
                fetchNewBookings: () => { },
            });
            return;
        }
        switch (type) {
            case 'url': {
                if (externalUrl) {
                    window.open(externalUrl, '_blank', 'noopener,noreferrer');
                }
                else {
                    console.warn('No valid URL found for notification:', selectedNotification);
                }
                return;
            }
            case 'folder': {
                if (folder) {
                    const parsed = new URL(folder.deeplink);
                    const path = parsed.pathname;
                    history.push(path);
                }
                else {
                    console.warn('No folder found :', folder);
                }
                return;
            }
            case 'activity': {
                helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, { content });
                return;
            }
        }
        helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
            activeItem: offerOrDirectory,
        });
    }
    const title = offerOrDirectory ? offerOrDirectory.title : activity ? activity.title : '';
    return (react_1.default.createElement(MessageListWrapper, null, !selectedNotification ? (react_1.default.createElement(SelectNotificationMsg, null,
        react_1.default.createElement(Notifications_1.default, { className: "notifications-icon" }),
        react_1.default.createElement(material_1.Typography, null,
            " ",
            i18n_js_1.default.t('notification_center_select_a_notification'),
            " "))) : (react_1.default.createElement(react_1.Fragment, null,
        messageType !== 'blank' && (react_1.default.createElement(MainNotificationContainer, { onClick: () => handleNotificationClick(selectedNotification, content, offerOrDirectory) }, messageType === 'activity' && fetchingActivity ? (react_1.default.createElement(CardSkeleton_1.CardSkeleton, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(MainNotificationImg, null, selectedNotification.thumbnailUrl ? (react_1.default.createElement("img", { src: selectedNotification.thumbnailUrl, alt: "placeholder" })) : (react_1.default.createElement("div", { className: "image-placeholder" }))),
            react_1.default.createElement(MainNotificationBody, null,
                react_1.default.createElement(PlaceAndDate, null,
                    react_1.default.createElement(PlaceName, null, !fetchingActivity && (activity === null || activity === void 0 ? void 0 : activity.placeName) && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(Place_1.default, null),
                        react_1.default.createElement(material_1.Typography, { variant: "body2" }, activity.placeName)))),
                    react_1.default.createElement(MainNotificationTimeAndDate, null, !fetchingActivity && (activityDate || activityTime) && (react_1.default.createElement(material_1.Typography, { className: `${dateTimeClassName}`, variant: "body2" }, `${activityDate || ''} ${activityTime || ''}`)))),
                react_1.default.createElement(material_1.Typography, { variant: "h6", className: "main-notification-title" }, title || selectedNotification.title || ''),
                react_1.default.createElement(NotificationAvailability, null,
                    offerOrDirectory && (0, ActivityListItem_1.renderBookingAvailability)(offerOrDirectory),
                    !fetchingActivity && activity && (0, ActivityListItem_1.renderBookingAvailability)(activity))),
            react_1.default.createElement(Launch_1.default, null))))),
        react_1.default.createElement("div", { className: "messages-container" }, messagesGroupedByDay &&
            messagesGroupedByDay.map((dayGroup) => (react_1.default.createElement("div", { className: "message-group", key: (0, react_uid_1.uid)(dayGroup) },
                react_1.default.createElement(material_1.Typography, { variant: "body2", className: "group-header" }, dayGroup.dateHeader.toLocaleUpperCase()),
                react_1.default.createElement("div", null, dayGroup.messages.map(msg => (react_1.default.createElement(Message_1.default, { key: msg.id, message: msg }))))))))))));
};
exports.MessageList = MessageList;
function groupMessagesPerDay(messages, currentLocale) {
    const messageGroups = [];
    let startDay = null;
    messages.forEach((message) => {
        const messageDate = helpers_1.Helpers.getDateFromStringDependingLocale(message.sentAt, currentLocale).date;
        if (startDay === messageDate) {
            messageGroups[messageGroups.length - 1].messages.push(message);
        }
        else {
            messageGroups.push({ dateHeader: messageDate, messages: [message] });
            startDay = messageDate;
        }
    });
    return messageGroups;
}
function getActivityTime(content, currentLocale) {
    if (!content) {
        return null;
    }
    if (!content.showStartTime && !content.showEndTime) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, currentLocale).time;
    const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.end, currentLocale).time;
    if (content.showStartTime && content.showEndTime) {
        return `${startTime} - ${endTime}`;
    }
    return startTime;
}
function getActivityDate(dateStart, currentLocale) {
    if (!dateStart) {
        return null;
    }
    const dayWeekMonthFormat = { weekday: 'short', month: 'short', day: 'numeric' };
    const { date } = helpers_1.Helpers.getDateFromStringDependingLocale(dateStart, currentLocale, undefined, true, dayWeekMonthFormat);
    return `${date},`;
}
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    directoryData: store.getValue('directory'),
    offers: store.getValue('offers'),
    userData: store.getValue('userData'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.MessageList));
